import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '@/shared/components/ui/Loader/Loader';
import { DEFAULT_LANDING_ROUTE } from '@/shared/utils/loginRedirect';
import { recordReferralClick } from '../../apis/referral';

/** /ref/:code - records the visit, then goes on to the store whatever the answer. */
const Referral = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  // StrictMode runs effects twice in development; one visit is one click
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    const goToStore = () => navigate(DEFAULT_LANDING_ROUTE, { replace: true });
    if (!code) {
      goToStore();
      return;
    }
    recordReferralClick(code)
      .catch(() => undefined)
      .finally(goToStore);
  }, [code, navigate]);

  return <Loader isOpen />;
};

export default Referral;
